
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"512pt","viewBox":"0 0 512 512","width":"512pt","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M256 0C116.512 0 0 116.14 0 256c0 139.488 116.14 256 256 256 139.488 0 256-116.14 256-256C512 116.512 395.86 0 256 0zm159.102 96.902c85.644 85.645 89.054 217.871 10.261 307.246L316.527 295.316l2.465-3.28a105.48 105.48 0 00-15.332-9.587l-41.285-41.289c27.09 1.254 52.758 10.473 74.574 26.875l18.031-23.976C326.22 222.429 291.988 211 256 211c-7.52 0-14.96.508-22.293 1.492l-25.578-25.578c15.48-3.91 31.52-5.914 47.871-5.914 42.523 0 82.96 13.504 116.937 39.05l18.032-23.976C351.75 166.586 305.079 151 256 151c-24.844 0-49.066 4-72.02 11.77l-23.332-23.332C190.656 127.28 222.844 121 256 121c55.605 0 108.484 17.66 152.922 51.074l18.027-23.98C377.273 110.742 318.16 91 256 91c-41.371 0-81.387 8.758-118.172 25.617l-29.976-29.976c89.375-78.793 221.601-75.383 307.25 10.261zM96.898 415.098C11.254 329.453 7.844 197.227 86.637 107.852l23.414 23.414a288.235 288.235 0 00-25.004 16.832l18.031 23.976A257.717 257.717 0 01132 153.214l22.148 22.153a226.757 226.757 0 00-33.117 20.707l18.028 23.98c11.804-8.878 24.394-16.296 37.574-22.202l23.023 23.02c-15.12 5.51-29.457 13.273-42.64 23.187l18.03 23.976c14.708-11.058 31.161-18.855 48.626-23.148l26.3 26.304c-20.69 1.16-40.277 8.297-56.968 20.844l18.023 23.98C224.102 306.192 239.648 301 256 301c10.512 0 20.684 2.156 30.086 6.297l118.062 118.062c-89.375 78.793-221.601 75.383-307.25-10.261zm0 0"}}),_c('path',{attrs:{"d":"M256 331c-24.813 0-45 20.188-45 45s20.188 45 45 45 45-20.188 45-45-20.188-45-45-45zm0 60c-8.27 0-15-6.73-15-15s6.73-15 15-15 15 6.73 15 15-6.73 15-15 15zm0 0"}})])
          )
        }
      }
    